import React, { useState } from 'react'
import FoodChoice from '../../components/food/choice'

import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { setFoodChoiceSuccess } from '../../actions/cacheActions'
import { getListFoodChoice } from '../../selectors'
import useDidMountEffect from '../../hooks/useDidMountEffect'
import { getActionViewFood } from '../../utils/view'
import { getFoodPriceShow } from '../../utils'
import { isFoodSoldOut } from '../../utils/order'

const FoodChoiceModal = () => {
    const dispatch = useDispatch()
    const foods = useSelector(getListFoodChoice)
    const location = useLocation()
    const [foodIndexSelected, setFoodIndexSelected] = useState(-1)
    const { currentPrice } = foods[foodIndexSelected]
        ? getFoodPriceShow(foods[foodIndexSelected])
        : {}

    const handleSubmitSelectFood = () => {
        dispatch(
            getActionViewFood({
                foodIndexSelected,
                ...foods[foodIndexSelected],
            })
        )
        setFoodIndexSelected(-1)
    }

    const handleClose = () => {
        dispatch(setFoodChoiceSuccess([]))
        setFoodIndexSelected(-1)
    }

    useDidMountEffect(() => {
        handleClose();
    }, [location])

    useDidMountEffect(() => {
        foods.length && setFoodIndexSelected(foods.findIndex(f => !isFoodSoldOut(f)));
    }, [ foods ]);

    return (
        <FoodChoice
            handleSelectFood={setFoodIndexSelected}
            handleSubmitSelectFood={handleSubmitSelectFood}
            handleClose={handleClose}
            isOpen={!!foods.length}
            foods={foods}
            foodIndexSelected={foodIndexSelected}
            currentFoodPrice={currentPrice || 0}
        />
    )
}

export default FoodChoiceModal
